import { CartDrawer as CDrawer } from '@iheartjane/cart';
import { Drawer } from '@iheartjane/reefer';

import { ClientOnly } from '@jane/bloom/components/clientOnly';

export const CartDrawer = () => {
  return (
    <ClientOnly>
      {(isMobile) => (
        <CDrawer isMobile={isMobile}>
          <Drawer.Header title="Bag" />
          <Drawer.Content>
            {null /** @todo Render cart contents */}
          </Drawer.Content>
        </CDrawer>
      )}
    </ClientOnly>
  );
};
